import { render, staticRenderFns } from "./WasteCategoryHeader.vue?vue&type=template&id=11be163e&scoped=true&"
import script from "./WasteCategoryHeader.vue?vue&type=script&lang=js&"
export * from "./WasteCategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./WasteCategoryHeader.vue?vue&type=style&index=0&id=11be163e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be163e",
  null
  
)

export default component.exports